import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ITariffList } from "../../../Pages/Tariff/ITariff";

export const AddTariffSlicer = createSlice({
  name: "AddTariff",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ITariffList>,
  reducers: {
    addTariff: (state, _) => {
      state.isLoading = true;
    },
    successAddTariff: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddTariff: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddTariffState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addTariff,
  failureAddTariff,
  successAddTariff,
  clearAddTariffState,
} = AddTariffSlicer.actions;

export default AddTariffSlicer.reducer;
